import { getCategoryAndSubcategory } from "@serophin/nottldr-shared";
import type { LandingTopic } from "../seedTypes";
import { Section, SectionHeading } from "./Section";

const PILL_CLASS =
  "block px-4 py-2 rounded-full text-sm font-medium bg-neutral-100 dark:bg-neutral-800 text-gray-800 dark:text-gray-100 border border-gray-200 dark:border-gray-700 hover:bg-neutral-200 dark:hover:bg-neutral-700 transition-colors";

export const Topics = ({ topics }: { topics: LandingTopic[] }) => (
  <Section class="bg-white dark:bg-neutral-950/40">
    <SectionHeading
      title="From black holes to better decisions"
      intro="Psychology, science, history, money, health, technology and more. Chances are, something here will hook you."
    />
    <ul class="flex flex-wrap justify-center gap-2.5 max-w-3xl mx-auto">
      {topics.map(({ category, subcategory }) => (
        <li key={`${category}.${subcategory}`}>
          <a href={`/articles?category=${category}&subcategory=${subcategory}`} class={PILL_CLASS} data-test-click="landing-topic">
            {getCategoryAndSubcategory(category, subcategory).subcategory.name}
          </a>
        </li>
      ))}
    </ul>
  </Section>
);
